export class AdminApproveEventsController {
	constructor($scope, $modal, EventService, RegionService, CityService, $timeout) {
		this.scope = $scope;
		this.modal = $modal;
		this.timeout = $timeout;
		this.EventService = EventService;
		this.RegionService = RegionService;
		this.CityService = CityService;
		this.scope.vm = this;
		this.scope.eventsSelected = {};
		this.scope.allEventsSelected = { state: false };
		this.scope.eventTypes = [];
        this.scope.allEvents = [];
        this.scope.events = [];
        this.scope.blogFormModel = {};
        this.scope.errors = [];
        this.scope.regions = [];
        this.scope.cities = [];
        this.scope.allCities = [];
    
        this.scope.pagination = {
            total: 0,
            currentPage: 1, 
            limit: 12
        };

        this.scope.filter = {
          confirmed: true,
          unconfirmed: true
        };

        this.scope.show = {
          list: true,
          edit: false
        };

		this.scope.feedback = {
          toId: '',
          fromId: '',
          reason: '',
          extraMessage: ''
        };

        this.scope.showModal = {
          feedback: false
        };
    
            this.scope.feedbackMessages = [
          {
            'id': 1,
            'text': 'Personal',
            'value': 'Estimado Usuario:\n\n\n\n\n\n' +
            '\nAtentamente\n' + 'Datingchile.cl' + '\n'
          },
              {
            'id': '2',
            'text': 'Generico',
            'value': 'Disculpa, hemos rechazado tu blog debido a que no cumple con las condiciones del sitio.\n'+
                     'Datingchile.cl' + '\n'
          }
        ];

		this.init();
	}

	init() {
		this.scope.changeLimit = () => {
      this.timeout.cancel(this.limitTimout);
      this.limitTimout = this.timeout(() => {
        this.scope.getEvents(1);
      }, 200);
    }

		this.scope.openFeedbackModal = () => {
      var stop = true;

      _.forEach(this.scope.eventsSelected, (value, key) => {
        if(value) {
          stop = false;
        }
      });

      if(stop) {
        return;
      }

      this.scope.hideModal();
      this.scope.showModal.feedback = true;
      //this.scope.feedback.toId = userId;
      $('#modal').modal('show');
    }

    this.scope.hideModal = () => {
      this.scope.showModal.feedback = false;
      this.scope.showModal.image = false;
    };

		this.scope.sendFeedback = (formReport) => {

      if (!formReport.$valid) {
        this.formValidationForReport(formReport);
        return;
      }

      if (this.scope.feedback.reason === "" || this.scope.feedback.extraMessage === "") {
        this.toastr.error('Feedback hasn\'t sent. You must add message');
        return;
      }

      this.scope.rejectEvents();
    }

    this.scope.filterEvents = () => {
      if(this.scope.filter.confirmed && this.scope.filter.unconfirmed) {
        var query = {};
        this.scope.getEvents(this.scope.pagination.currentPage, query);
      }
      else if(this.scope.filter.confirmed && !this.scope.filter.unconfirmed) {
        query = {status: 1};
        this.scope.getEvents(this.scope.pagination.currentPage, query);
      } else if(!this.scope.filter.confirmed && this.scope.filter.unconfirmed) {
        query = {status: 2};
        this.scope.getEvents(this.scope.pagination.currentPage, query);
      } else {
        this.scope.allEvents = [];
        this.scope.pagination.total = 0;
        this.scope.eventsSelected = {};
      }
    }

    this.scope.selectAllEvents = () => {
      var check = this.scope.allEventsSelected.state;
      _.forEach(this.scope.eventsSelected, (val, key) => {
        this.scope.eventsSelected[key] = !!check;
      })
    }

    this.scope.approveEvents = () => {
			if(!confirm('Do you really want to approve event?')) {
				return;
			}

      var countdown = 0;

      _.forEach(this.scope.eventsSelected, (val, key) => {
        if (val) {
          countdown++;
          this.EventService.approveEvents(key)
            .then((response) => { let result = response.data;
              countdown--;
              if (countdown == 0) {
                this.refreshPage();
              }
            })
            .catch((response) => { let err = response.data;
              countdown--;
              if (countdown == 0) {
                this.refreshPage();
              }
            });
        }
      });
    }

    this.scope.rejectEvents = () => {
				if(!confirm('Do you really want to reject event?')) {
					return;
				}

        var countdown = 0;

        _.forEach(this.scope.eventsSelected, (val, key) => {
          if (val) {
            countdown++;
            this.EventService.rejectEvents(key, {
							reason: this.scope.feedback.reason,
							motivation: this.scope.feedback.extraMessage
						})
              .then((response) => { let result = response.data;
                countdown--;
                if (countdown == 0) {
									// Reset fields
			            this.scope.feedback.reason = '';
			            this.scope.feedback.extraMessage = '';

			            $('#modal').modal('hide');
                  this.refreshPage();
                }
              })
              .catch((response) => { let err = response.data;
                countdown--;
                if (countdown == 0) {
									// Reset fields
			            this.scope.feedback.reason = '';
			            this.scope.feedback.extraMessage = '';

			            $('#modal').modal('hide');
                  this.refreshPage();
                }
              });

          }
        });
      }

    this.scope.removeEvents = () => {
				if(!confirm('Do you really want to delete event?')) {
					return;
				}

        var countdown = 0;

        _.forEach(this.scope.eventsSelected, (val, key) => {
          if (val) {
            countdown++;
            this.EventService.removeEvents(key)
              .then((response) => { let result = response.data;
                countdown--;
                if (countdown == 0) {
                  this.refreshPage();
                }
              })
              .catch((response) => { let err = response.data;
                countdown--;
                if (countdown == 0) {
                  this.refreshPage();
                }
              });
            }
        });
      }

    this.scope.editEvent = (event) => {
      this.scope.show.edit = true;
      this.scope.show.list = false;

      this.scope.eventFormModel = angular.copy(event);
      this.scope.eventFormModel.details.dateclose = new Date(this.scope.eventFormModel.details.dateclose);
      this.scope.eventFormModel.details.dateevent = new Date(this.scope.eventFormModel.details.dateevent);
      this.scope.eventFormModel.details.dateopen = new Date(this.scope.eventFormModel.details.dateopen);
      this.scope.eventFormModel.published = new Date(this.scope.eventFormModel.published);
      this.scope.eventFormModel.suspended = new Date(this.scope.eventFormModel.suspended);
			this.scope.changeRegion();
    }

    this.scope.updateEvent = (form) => {
      this.scope.errors = [];
      _.forEach(form, (obj, key) => {
        if(key[0] == "$") {
          return;
        }

        _.forEach(obj.$error, (err, keyErr) => {
          if(keyErr == 'required') {
            this.scope.errors.push('The ' + key + ' is required!')
          }
        })
      })

      if(this.scope.errors.length) {
        return false;
      }

      this.EventService.updateEvent(this.scope.eventFormModel)
        .then((response) => { let result = response.data;
          this.refreshPage();
        })
        .catch((response) => { let err = response.data;
          console.error(err);
        });
    }

    this.scope.getEvents = (page, query) => {
      this.scope.pagination.currentPage = page;
      this.EventService.getAllEvents(page, this.scope.pagination.limit, query)
        .then((response) => { let data = response.data;
          this.scope.allEvents = data.data;
          this.scope.pagination.total = data.itemCount;

          _.forEach(this.scope.allEvents, (event) => {
            this.scope.eventsSelected[event._id] = false;
          });

          this.scope.allEventsSelected.state = false;
        })
        .catch((response) => { let err = response.data;
          console.error(error);
        });
    }

		this.scope.changeRegion = () => {
			this.scope.cities = [];
			let region = this.scope.eventFormModel.place.region._id;

			_.forEach(this.scope.allCities, (city) => {
				if(city.region == region) {
					this.scope.cities.push(city);
				}
			});
		}

		this.EventService.getTypes()
		.then((response) => { let types = response.data;
			this.scope.eventTypes = types.data;
		})
		.catch((response) => { let err = response.data;
			console.error(err);
		});

		this.RegionService.getRegionsList()
		.then((response) => { let regions = response.data;
			this.scope.regions = regions.data;
		})
		.catch((response) => { let err = response.data;
			console.error(err);
		});

		this.CityService.getCitiesList()
		.then((response) => { let cities = response.data;
			this.scope.allCities = cities.data;
		})
		.catch((response) => { let err = response.data;
			console.error(err);
		});

		this.scope.filterEvents();
	}

  refreshPage() {
    this.scope.filterEvents();
    this.scope.show.edit = false;
    this.scope.show.list = true;
  }

}
